import { useQuery } from 'src/shared/lib/useQuery';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { QueryResult } from 'src/shared/types/util.types';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { ClassificationModelListItem } from 'src/shared/types/classification-model.types';

export function useClassificationModels(): QueryResult<ClassificationModelListItem[]> {
  const { orgFetch, currentOrg } = useOrg();

  const queryKey = ['next-gen', 'models', 'classification', genQueryKey(currentOrg.id)];

  return useQuery({
    queryFn: getData,
    queryKey: queryKey,
    staleTime: 0,
  });

  async function getData() {
    const res = await orgFetch<ClassificationModelListItem[]>(`/api/v2/next-gen-models/classification`);
    if (!res.ok) {
      throw new Error('Failed to fetch classification models');
    }
    const models = await res.json();

    return models;
  }
}
